import { SolutionsModel } from "../ListPanel/ListPanelModel";
import { ProductModel } from "../ShowcasePanel/ShowcasePanelModel";
import { SliderPanelModel } from "./SliderPanelModel";

class SliderPanelUtils {
  static getFeatureIndex = (
    entity: ProductModel,
    tier: string | undefined
  ): number => {
    if (entity?.productType === "Subscription") {
      return entity.featureList.thead.findIndex((x) => x.value === tier);
    }
    return 1;
  };

  static getPrice = (
    entity: ProductModel,
    displayAnnuallyOrMonthlySwitch: boolean,
    monthlyValue: string | null,
    annuallyValue: string | null,
    isChecked: boolean,
    monthlyFormattedValue: string,
    annuallyFormattedValue: string
  ): string => {
    if (entity?.productType === "Subscription") {
      if (displayAnnuallyOrMonthlySwitch) {
        return isChecked ? monthlyFormattedValue : annuallyFormattedValue;
      } else {
        if (monthlyValue && annuallyValue) {
          return `$${monthlyValue}/mo or $${annuallyValue}/yr`;
        } else if (monthlyValue) {
          return `$${monthlyValue}/mo`;
        } else {
          return `$${annuallyValue}/yr`;
        }
      }
    } else {
      return entity?.perpetualProductPrice;
    }
  };

  static getSubscriptionIndex = (
    entity: ProductModel,
    tier: string | undefined
  ): number => {
    return entity?.subscriptionIntervalPrice?.thead &&
      entity?.subscriptionIntervalPrice?.thead?.length > 0
      ? entity?.subscriptionIntervalPrice.thead.findIndex(
          (x) => x.value.toLowerCase() === `${tier} USD`.toLowerCase()
        )
      : -1;
  };

  static getSelectedItem(blok: SliderPanelModel) {
    const selectedItem = blok?.items?.find((x) => x.isDefaultSelected);
    if (
      selectedItem?.entity &&
      selectedItem.entity.length > 0 &&
      (selectedItem.entity[0].content.productName ||
        (selectedItem.entity[0].content as SolutionsModel).name)
    ) {
      return selectedItem.entity[0].content.productName
        ? selectedItem.entity[0].content.productName + selectedItem.tier
        : (selectedItem.entity[0].content as SolutionsModel).name;
    } else if (
      blok?.items?.length > 0 &&
      blok.items[0].entity &&
      blok.items[0].entity[0]?.content?.productName
    ) {
      return blok?.items[0].entity[0].content.productName + blok?.items[0].tier;
    } else if (
      blok?.items?.length > 0 &&
      blok.items[0].entity &&
      blok?.items[0].entity[0].content &&
      (blok?.items[0].entity[0].content as SolutionsModel).name
    ) {
      return (blok?.items[0].entity[0].content as SolutionsModel).name;
    }
    return "";
  }
}

export default SliderPanelUtils;
